import { Panel } from "components/Panel/Panel";
import { PanelHeader } from "components/Panel/styles";
import {
  selectTournaments,
  selectTournamentsAndToursByStatus,
} from "selectors/Tournament";
import { EmptyGrowPanelText } from "styles/text";
import {
  TournamentsOptionsColumn,
  TournamentOptions,
  TournamentsOptionsContainer,
} from "./styles";
import { TournamentOption } from "./TournamentOption";
import { selectTours } from "selectors/Tour";
import { Tournament, TournamentStatus } from "model/Tournament/Tournament";
import { Tour } from "model/Tour/Tour";
import { TourOption } from "./TourOption";
import { useAppSelector } from "app/hooks";

interface Props {
  tournamentIds: string[];
  tourIds: string[];
}

export const TournamentsList = ({ tournamentIds, tourIds }: Props) => {
  const tours = useAppSelector((state) => selectTours(state, tourIds));
  const tournaments = useAppSelector((state) =>
    selectTournaments(state, tournamentIds)
  );

  const completed = useAppSelector((state) =>
    selectTournamentsAndToursByStatus(
      state,
      tournaments,
      tours,
      "Completed",
      "Descending"
    )
  );

  const ongoing = useAppSelector((state) =>
    selectTournamentsAndToursByStatus(
      state,
      tournaments,
      tours,
      "Ongoing",
      "Ascending"
    )
  );

  const upcoming = useAppSelector((state) =>
    selectTournamentsAndToursByStatus(
      state,
      tournaments,
      tours,
      "Upcoming",
      "Ascending"
    )
  );

  // todo - extract No ... For The Selected Filters and similar
  if (tournaments.length === 0) {
    return (
      <Panel>
        <EmptyGrowPanelText>
          No Tournaments For The Selected Filters
        </EmptyGrowPanelText>
      </Panel>
    );
  }

  return (
    <TournamentsOptionsContainer>
      <TournamentsOptionsColumn>
        <PanelHeader>Ongoing / Upcoming</PanelHeader>
        {ongoing.length === 0 && upcoming.length === 0 && (
          <TournamentOptions>
            <Panel>
              <EmptyGrowPanelText>
                No Tournaments For The Selected Filters
              </EmptyGrowPanelText>
            </Panel>
          </TournamentOptions>
        )}
        <TournamentOptions>
          {ongoing.map((item) => getOption(item, "Ongoing"))}
          {upcoming.map((item) => getOption(item, "Upcoming"))}
        </TournamentOptions>
      </TournamentsOptionsColumn>
      <TournamentsOptionsColumn>
        <PanelHeader>Completed</PanelHeader>
        {completed.length === 0 && (
          <TournamentOptions>
            <Panel>
              <EmptyGrowPanelText>
                No Tournaments For The Selected Filters
              </EmptyGrowPanelText>
            </Panel>
          </TournamentOptions>
        )}
        <TournamentOptions>
          {completed.map((item) => getOption(item, "Completed"))}
        </TournamentOptions>
      </TournamentsOptionsColumn>
    </TournamentsOptionsContainer>
  );
};

const getOption = (
  item:
    | {
        type: "Tournament";
        data: Tournament;
      }
    | {
        type: "Tour";
        data: Tour;
      },
  status: TournamentStatus
) => {
  if (item.type === "Tournament") {
    return (
      <TournamentOption
        key={item.data.id}
        tournament={item.data}
        status={status}
      />
    );
  }

  return <TourOption key={item.data.id} tour={item.data} status={status} />;
};
